var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.env !== 'prod' && _vm.env !== 'test')?_c('div',{staticClass:"p-5 my-5 bg-yellow-200 border border-black border-dashed"},[_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"mt-10 text-sm italic"},[_vm._v("Wiadomość widoczna tylko na środowisku testowym")])],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }